import {
  FETCH_INQUIRIES,
  FETCH_INQUIRIES_ERROR,
  CHANGE_INQUIRY_STATUS,
  CHANGE_INQUIRY_STATUS_ERROR,
  FETCH_INQUIRY_STAFF_COMMENTS,
  FETCH_INQUIRY_STAFF_COMMENTS_ERROR,
  ADD_INQUIRY_STAFF_COMMENTS,
  ADD_INQUIRY_STAFF_COMMENTS_ERROR,
} from '../actions/inquiryActions';

export const initialState = {
  inquiriesList: [],
  inquiriesListError: null,
  updatedInquiry: null,
  updatedInquiryError: null,
  inquiryStaffComments: null,
  inquiryStaffCommentsError: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case FETCH_INQUIRIES:
      return {
        ...state,
        inquiriesList: action.payload,
        inquiriesListError: null,
      };
    case FETCH_INQUIRIES_ERROR:
      return {
        ...state,
        inquiriesList: [],
        inquiriesListError: action.payload,
      };
    case CHANGE_INQUIRY_STATUS:
      return {
        ...state,
        updatedInquiry: action.payload,
        updatedInquiryError: null,
      };
    case CHANGE_INQUIRY_STATUS_ERROR:
      return {
        ...state,
        updatedInquiry: null,
        updatedInquiryError: action.payload,
      };
    case FETCH_INQUIRY_STAFF_COMMENTS:
    case ADD_INQUIRY_STAFF_COMMENTS:
      return {
        ...state,
        inquiryStaffComments: action.payload,
        inquiryStaffCommentsError: null,
      };
    case FETCH_INQUIRY_STAFF_COMMENTS_ERROR:
    case ADD_INQUIRY_STAFF_COMMENTS_ERROR:
      return {
        ...state,
        inquiryStaffComments: null,
        inquiryStaffCommentsError: action.payload,
      };
    default:
      return state;
  }
}
